import { ATTRIBUTION_KEY, ISLOCALHOST } from "appConfig";
import localObject from "utilities/localObject";
import { AnalyticsBrowser } from "@segment/analytics-next";
import { isbot } from "isbot";

let analyticsLoaded = false;

export function enableAnalytics() {
  const analytics = new AnalyticsBrowser();

  if (typeof window !== "undefined") {
    window.analytics = analytics;

    if (analyticsLoaded) {
      console.info("Skipping analytics already loaded");
    } else if (ISLOCALHOST && !process.env.GATSBY_ENABLE_LOCAL_ANALYTICS) {
      // eslint-disable-next-line
      console.info("Skipping loading of analytics for localhost");
    } else if (navigator.userAgent && isbot(navigator.userAgent)) {
      //Skip loading of  analytics for bots
      // eslint-disable-next-line
      console.warn("Suspected bot with user agent: " + navigator.userAgent);
    } else {
      const startSegment = () => {
        window?.analytics?.ready(() => {
          if (typeof window.ga === "function") {
            //Install ready callback into GA
            window.ga(function (tracker) {
              //extract the GA clientId from the cookie and store it for sending to server in sign up call
              const gaClientId = tracker.get("clientId");
              // eslint-disable-next-line @typescript-eslint/ban-types
              const [attribution] = localObject.getValue<Record<string, any>>(
                ATTRIBUTION_KEY,
                {},
              );
              localObject.setValue(ATTRIBUTION_KEY, {
                ...attribution,
                gaClientId,
              });
            });
          } else {
            console.log("GA not found");
          }

          /*
          This stores super property against current user identity
          It will only be saved once, first time user lands on any page
           */
          if (window.mixpanel) {
            window.mixpanel.people.set_once({
              "Initial Landing Url": window.location.href,
            });
          }

          console.log("Analytics.js ready");
        });
        const writeKey =
          window.___SEGMENT_WEBVIEW_WRITE_KEY ||
          process.env.GATSBY_SEGMENT_PROD;
        if (writeKey) {
          analytics.load({ writeKey });
        }
        console.log("Analytics.js has been loaded.");
      };

      // Defer the Segment load (and the integration cascade it triggers: GTM,
      // GA4, Facebook, TikTok, Braze, FullStory, Trade Desk) until the browser
      // is idle, so it doesn't compete with first paint. window.analytics is
      // already assigned above, so any .track() / .identify() calls made
      // before this fires are queued by the SDK and flushed on load.
      if (typeof window.requestIdleCallback === "function") {
        window.requestIdleCallback(startSegment, { timeout: 3000 });
      } else {
        setTimeout(startSegment, 2000);
      }
      analyticsLoaded = true;
    }
  }
}
